module.exports = __webpack_public_path__ + "img/testpaper_up_normal.36d208f6.svg";